import { Environment } from '@core/models/global.models';

const certification: Environment = {
  appName: 'Direct Connections CERT',
  production: false,
  apiConfig: {
    cashProcessorUrl:
      'https://cert.experience.cash.monnet.io/api/v1/ms-experience-monnet-cash/payment/voucher',
    payinCheckoutBackendUrl:
      'https://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/',
    voucherPayinExperienceUrl:
      'https://cert.experience.cash.monnet.io/api/v1/ms-experience-monnet-cash/transaction/voucher-data/',
    webSocket:
      'wss://cert.payin.experience.monnet.io/api/v1/payin-checkout-experience/ws',
    payinMetricExperienceUrl: 'https://cert.payin.experience.monnet.io/ms-payin-metric-experience'
  }
};

export const environment = certification;
